import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "markdown-list-bullet-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none" },
        React.createElement("circle", { cx: 4, cy: 3.5, r: 1, fill: "currentColor", fillRule: "evenodd" }),
        React.createElement("circle", { cx: 4, cy: 8.5, r: 1, fill: "currentColor", fillRule: "evenodd" }),
        React.createElement("circle", { cx: 4, cy: 13.5, r: 1, fill: "currentColor", fillRule: "evenodd" }),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M7.5 3.5h6m-6 5h6m-6 5h6" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
